export const CATEGORY_LINE = 1
export const CATEGORY_FAMILY = 2
export const CATEGORY_GROUP = 3
